// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2mUtj","header":"PatientQuestionnaire_header__2BOy_","info":"PatientQuestionnaire_info__2oJJQ"};